import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

import { Ledger } from "./ledger";
import { Accountsgroup } from "../../accountsgroup/shared/accountsgroup";

@Injectable({
  providedIn: 'root'
})

export class LedgerService {

  selectedLedger: Ledger;
  LedgerList: Ledger[];
  selectedAccountsgroup: Accountsgroup;

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {

    return environment.baseUrl;
  }

  IUDLedger(ledger: Ledger) {

    ledger.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];    
    // ledger.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    ledger.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    ledger.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    ledger.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    ledger.CreatedDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    let body = ledger;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Ledger/IUD', body, { headers: headers });
  }

  GetAccountGroupList() {
    this.selectedAccountsgroup = new Accountsgroup();

    let body = this.selectedAccountsgroup;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/AccountsGroup/FetchList', body, { headers: headers });
  }

  // GetAccountGroupList() {
  //   this.selectedLedger = new Ledger();
  //   this.selectedLedger.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
  //   this.selectedLedger.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
  //   this.selectedLedger.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
  //   this.selectedLedger.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

  //   let body = null;
  //   const headers = new HttpHeaders();
  //   headers.set('Content-Type', 'application/json; charset=utf-8');
  //   return this.httpClient.post<any>(this.getBaseUrl() + 'api/AccountsGroup/AccountGroup/FetchList', body, { headers: headers });
  //   // return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/AccountGroup', body, { headers: headers });
  // }

  FetchLedgerById(ledger) {

    ledger.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    ledger.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    // ledger.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    ledger.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    ledger.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = ledger;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Ledger/Fetch', body, { headers: headers });
  }

  //-----------------------------FetchGroupList----Component-------------------------------------
  FetchLedgerList() {

    this.selectedLedger = new Ledger();
    this.selectedLedger.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLedger.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLedger.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLedger.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLedger.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLedger;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Ledger/FetchList', body, { headers: headers });
  }

  FetchLedgerByNames(name : any) {

    this.selectedLedger = new Ledger();

    this.selectedLedger.LedgerName = name; 
    this.selectedLedger.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    // this.selectedLedger.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLedger.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLedger.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLedger.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLedger;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Ledger/LedgerSearch', body, { headers: headers });
  }
}


